import { useEffect, useState } from "react"

export const useExt = () => {
  const [isReady, setIsReady] = useState(true)

  useEffect(() => {
    const fn = (event: MessageEvent) => {
      if (event.data?.action === "extension-is-ready") {
        clearTimeout(timer)
        setIsReady(true)
      }
    }

    window.addEventListener("message", fn)
    window.postMessage({ action: "check-extension-is-ready" }, "*")

    const timer = setTimeout(() => setIsReady(false), 100)

    return () => {
      clearTimeout(timer)
      window.removeEventListener("message", fn)
    }
  }, [])

  return isReady
}
